import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  customer: null,
  customerList: [],
};

const route = "modules/settings/views/workOrderType/modals/deleteManageWorkOrderType/redux/slice";

export const workOrderDeleteCustomer = createAsyncThunk("manage/deleteManageWorkOrderType/bulkDeleteCustomer", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteCustomer ($ids: [Int!]) {
        result: bulkDeleteCustomer (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteCustomer");
    return rejectWithValue(exc);
  }
}
);


const workOrdersDeleteCustomerRedux = createSlice({
  name: "workOrders/deleteCustomer",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteCustomer(state, action) {
      state.open = true;
      state.customer = action?.payload?.customer;
      state.customerList = action?.payload?.customerList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageWorkOrderType
    builder.addCase(workOrderDeleteCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderDeleteCustomer.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(workOrderDeleteCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersDeleteCustomerRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteCustomer } = actions;

// Export the reducer, either as a default or named export
export default reducer;